var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-lg-5"},[_c('h1',[_vm._v("Galeria")]),_c('hr'),_c('div',{staticClass:"row"},_vm._l((_vm.galleries),function(gallery){return _c('gallery-card',{key:gallery.slug,attrs:{"gallery":gallery}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }